import React from 'react';
import GTMDataLayer from './gtm';

const FilterContentType = (props) => {

  const handleResourceTypeFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, resType: e.target.value, page: 0});

      // Get name of the selected resource type for GTM.
      const selectedType = props.resType.find(item => item.id == e.target.value);

      // Track Resource Type changes.
      GTMDataLayer({
        event: 'filter_resource_type',
        pageUrl: location.href,
        filter_type: selectedType ? selectedType.name : 'All'
      });
    }
  };

  return (
    <div className='filter-resource-type'>
      <h3>{Drupal.t('Resource Type')}</h3>
      <div>
        <select onChange={handleResourceTypeFilter} defaultValue={props.selected}>
          <option value='all'>{Drupal.t('All')}</option>
          {props.resType.map((item, i) => (
            <option key={i} value={item.id}>{item.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterContentType;